import React from 'react';
import { SettingGroupGrid, ValueBox } from '../../FormWidgets/SettingGroup';
import { FormHelperText, MenuItem, Typography } from '@material-ui/core';
import { Select } from '../../FormWidgets/Select';
import { InfoButton } from '../../FormWidgets/Description';
import CirculationSettings from '../Ventilation/CirculationSettings';
import TankRefillControls from '../Nutrition/TankRefillControls';
import { tankRoutes } from '../../Utils/nutrition_utils';
import { availableScheduleFillingTanks } from '../../Utils/scheduling_utils';
import { useTranslation } from 'react-i18next';

export function ScheduledCirculation({ controller, parent, values, phase, index, controls }) {
  const indices = (phase.circulation ?? []).flatMap((_, row) =>
    values.schedule_meta.schedule_circulation_bitmap & (1 << row) ? [row] : []);
  if (!indices.length) return null;
  return <CirculationSettings
    controller={controller}
    values={phase.circulation}
    saved={parent.settings.scheduling.schedule_values.scheduling_values
      .find((entry) => entry.phase_id === phase.phase_id)?.circulation}
    controls={controls}
    pathPrefix={`schedule_values.scheduling_values[${index}].circulation`}
    indices={indices}
    actions={false}
    disabled={!controller.access_rights.scheduling?.write}
  />;
}

export function ScheduledTankFilling({ controller, parent, values, phase, index, controls }) {
  const { t } = useTranslation();
  const nutrition = parent.settings.nutrition;
  const availableTanks = availableScheduleFillingTanks(parent);
  const saved = parent.settings.scheduling.schedule_values.scheduling_values
    .find((entry) => entry.phase_id === phase.phase_id);
  return (phase.tank_filling ?? []).map((row, rowIndex) => {
    const tank = availableTanks.find((entry) => entry.tank_id === row.tank_id);
    if (!tank || !(values.schedule_meta.schedule_tank_filling_bitmap & (1 << row.tank_id)))
      return null;
    const live = parent.settings.irrigation_tank_info?.find((entry) => entry.tank_id === row.tank_id);
    const savedTank = saved?.tank_filling?.find((entry) => entry.tank_id === row.tank_id);
    const routes = tankRoutes(tank, nutrition?.routes);
    const routeUnavailable = row.selected_route_id !== 0 &&
      !routes.some((route) => route.route_id === row.selected_route_id);
    const pathPrefix = `schedule_values.scheduling_values[${index}].tank_filling[${rowIndex}]`;
    const routeLabelId = `${pathPrefix}.route-label`;
    return <SettingGroupGrid key={row.tank_id} controller={controller}
      label={live?.name || t('tank_id', { id: row.tank_id })}>
      <ValueBox controller={controller} id="tank_filling_route">
        <Typography id={routeLabelId}>
          {t('tank_filling_route')}
          <InfoButton content={t('schedule_tank_filling_portable')} />
        </Typography>
        <Select fullWidth labelId={routeLabelId} value={row.selected_route_id}
          controller_value={savedTank?.selected_route_id}
          error={routeUnavailable}
          disabled={!controller.access_rights.scheduling?.write}
          onChange={(event) => controls.setValue(`${pathPrefix}.selected_route_id`, Number(event.target.value))}>
          <MenuItem value={0}>{t('tank_filling_disabled')}</MenuItem>
          {routes.map((route) => <MenuItem key={route.route_id} value={route.route_id}>
            {route.name} ({route.route_id})
          </MenuItem>)}
          {routeUnavailable && <MenuItem value={row.selected_route_id} disabled>
            {nutrition?.routes?.find((route) => route.route_id === row.selected_route_id)?.name || t('unknown')}
            {' '}({row.selected_route_id})
          </MenuItem>}
        </Select>
        {routeUnavailable && <FormHelperText error>{t('tank_route_unavailable')}</FormHelperText>}
      </ValueBox>
      <TankRefillControls
        controller={controller}
        parent={parent}
        tank={savedTank ?? tank ?? row}
        draft={row}
        controls={controls}
        pathPrefix={pathPrefix}
        actions={false}
        disabled={!controller.access_rights.scheduling?.write}
      />
    </SettingGroupGrid>;
  });
}
